<template>
    <div class="o-container">
        <div class="o-box u-bg-color-5 -box-padding-sm">    
            <p class="-p-lg">{{ t("Veuillez sélectionner un type de personnel et une catégorie") }}</p>    
            <div class="o-box__inner">
                <div class="o-box__item">
                    <div class="o-form">
                        <div class="o-form-row -col-1/2">
                            <div class="o-form__item">
                                <div class="o-select__wrap">
                                    <label class="o-label sr-only" for="admission-type"></label>
                                    <select class="o-select" v-model="selectedNom">
                                       <option value="">{{ t("Qui êtes-vous?") }}</option>
                                       <option v-for="nom in personnaNoms" :value="nom">{{ nom }}</option>                                      
                                    </select>
                                    <svg class="o-ico -ico-arrow-down" aria-hidden="true" tabindex="-1" role="img">
                                        <use xlink:href="/assets/img/sprite.svg#arrow-down"></use>
                                    </svg>
                                </div>
                            </div>
                            <div class="o-form__item">
                                <div class="o-select__wrap">
                                    <label class="o-label sr-only" for="admission-type"></label>
                                    <select class="o-select" v-model="selectedType">                                       
                                        <option value="">{{ t("Catégories") }}</option>
                                        <option v-for="t in sortedSujetTypes" :value="t">{{ t }}</option>                                        
                                    </select>
                                    <svg class="o-ico -ico-arrow-down" aria-hidden="true" tabindex="-1" role="img">
                                        <use xlink:href="/assets/img/sprite.svg#arrow-down"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-admission-preparation__wrap js-admission-preparation__wrap">
                        <div class="o-spacer -spacer-xs"></div>
                        <div v-if="selectedTexte==''" class="c-admission-preparation-default o-text">
                            
                        </div>
                        <div v-else class="">
                            <div class="c-admission-result o-text" v-html="selectedTexte"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PersonnesRH',
    data() {
        return {
            selectedNom: '',
            selectedType: '',           
        }
    },
    watch: {
        selectedNom() {
            this.selectedType = ''
        }
    },
    computed: {
        selectedTexte() {
            const personneRH = this.personnesRH.find(personneRH => personneRH.nom === this.selectedNom && personneRH.type === this.selectedType)
            return personneRH ? personneRH.texte : ''
        },

        sortedSujetTypes() {
    return this.sujetTypes.slice().sort((a, b) => a.localeCompare(b));
  },
        personnaNoms() {
            let noms = this.personnesRH.map(personneRH => personneRH.nom)
            noms = [...new Set(noms)]

            let order = [             
                'Personnel de gestion (cadre)',  
                'Personnel de soutien syndiqué et non-syndiqué',
                'Personnel du corps enseignant', 
                'Personnel chargé de cours',  
                'Personnel de recherche',
                'Personnel auxiliaire (enseignement et recherche)',
            ];
            let order_en = [
                'Personnel de gestion (cadre)',  
                'Personnel de soutien syndiqué et non-syndiqué',
                'Personnel du corps enseignant', 
                'Personnel chargé de cours',  
                'Personnel de recherche',
                'Personnel auxiliaire (enseignement et recherche)',                
            ];

            if (document.documentElement.lang === 'en-CA') {
                order = order_en;
            }

            noms.sort((a, b) => order.indexOf(a) - order.indexOf(b))

            return noms
        },
        sujetTypes() {
            return this.personnesRH.filter(personneRH => personneRH.nom === this.selectedNom).map(personneRH => personneRH.type)
        }
    },
    methods: {
        t(string) {
            return PersonnesRHLocalisation[string]
        }
    }
}
</script>